import React, {FC, useCallback, useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAllSubscriptions, searchSubscription } from '../../../common/async/AsyncCalls';
import { IUserState } from '../../../common/state/profile/user';
import SimpleSpinner from '../../../components/loaders/spinners/SimpleSpinner';
// custom
import NavbarAdmin from '../../../components/navbar/Navbar.admin';
import SubscriptionAdminMuiTable from '../../../components/tables/Subscription.admin.material.table';

export type ISubscriptionTableData = {
    id: string,
    email: string,
    name: string,
    country: string,
    contact: string,    
    event_id: string,
    event_title: string,
    reg_type: string,
    payment_type: string,
    amount?: number,
    status?: string
};

const SubscriptionView : FC = () => {
    const history = useHistory();
    // states
    const token = useSelector(({user} : {
        user: IUserState
    }) => user.token);
    const [isLoading, toggleLoading] = useState(false);
    const [subscriptionList, setSubscriptionList] = useState<ISubscriptionTableData[]>([]);

    // evt handlers
    const handleRowSelect = (id: string) => {
        console.log('Subscription selected: ', id);
        history.push({pathname: `/admin/subscriptions/${id}`});
    };

        const fetchSubscriptionsByQuery = useCallback(async (text: string)=>{
        if (!token || token === '') return;
        try {
            toggleLoading(true);
            const response = await searchSubscription(token, text);
            const response_list = response.data;
            if (!response_list) return;
            console.log('Response list data: ', response_list);
            const subscriptionList: ISubscriptionTableData[] = response_list.map((item: any, _: number) => {
                const record: ISubscriptionTableData = {
                    id: item.id,
                    email: item.personal_info?.email,
                    name: `${item.personal_info?.first_name} ${item.personal_info?.last_name}`,                    
                    country: item.personal_info?.country ?? '',
                    contact: `${item.personal_info?.contact??''}`,
                    reg_type: item.general_info?.reg_type,
                    payment_type: item.general_info?.payment_type?? `offline`,
                    amount: item.general_info?.final_price,
                    event_id: item.general_info?.event_id,
                    event_title: item.general_info?.event_title,
                    status: item.general_info?.status
                };
                return record;
            });
            setSubscriptionList(subscriptionList);
        } catch (err) {
            toast(`Error querying subscription!`);
            console.log('Error querying subscription', err);
        } finally {
            toggleLoading(false);
        }
    },[token]);
    
    // fetch all subscription
    const fetchAllSubscription = useCallback(async()=>{
        if (!token || token === '') return;
        try {
            toggleLoading(true);
            const response = await getAllSubscriptions(token);
            const response_list = response.data;
            console.log('Subscribed users: ', response_list);
            if (response_list && response_list.length > 0) {
                const subscriptionList: ISubscriptionTableData[] = response_list.map((item: any, _: number) => {
                    const record: ISubscriptionTableData = {
                        id: item.id,
                        email: item.personal_info?.email,
                        name: `${item.personal_info?.first_name} ${item.personal_info?.last_name}`,
                        country: item.personal_info?.country ?? '',
                        contact: `${item.personal_info?.contact??''}`,
                        reg_type: item.general_info?.reg_type,
                        payment_type: item.general_info?.payment_type?? `offline`,
                        amount: item.general_info?.final_price,
                        event_id: item.general_info?.event_id,
                        event_title: item.general_info?.event_title,
                        status: item.general_info?.status
                    };
                    return record;
                });
                setSubscriptionList(subscriptionList);
            }
        } catch (err) {
            toast(`Error fetching subscription!`);
            console.log('Error fetching subscriptions', err);
        } finally {
            toggleLoading(false);
        }    
    },[token]);

    
    useEffect(()=>{
        fetchAllSubscription();
    },[]);
    return <React.Fragment>
        <NavbarAdmin/>
        <div
            className="flex flex-col items-center justify-start min-h-screen bg-gray-200 dark:bg-gray-800">
                {isLoading ? <SimpleSpinner loading={isLoading} title={'Fetching subscriptions'}/> : <div className='flex flex-col w-full p-4'>
                <div className="flex justify-end mb-4">
                <button
                    className="flex px-6 py-3 mb-1 mr-1 text-sm font-bold text-white uppercase transition-all duration-150 ease-linear rounded shadow outline-none bg-primary-500 active:bg-primary-600 hover:shadow-lg focus:outline-none"
                    onClick={()=> fetchAllSubscription()}>
                        Refresh
                </button>
                </div>
                <SubscriptionAdminMuiTable 
                    list={subscriptionList}
                    onRowSelect={handleRowSelect}/>
                    </div>}
        </div>
    </React.Fragment>;
};

export default SubscriptionView;
